import PropTypes from 'prop-types';

export const CustomScrollbarTrackVisibility = {
    none:                           'none',
    always:                         'always',
    auto:                           'auto'
};

//
CustomScrollbarTrackVisibility.all = Object.values(CustomScrollbarTrackVisibility);

CustomScrollbarTrackVisibility.default = CustomScrollbarTrackVisibility.auto;

export const CustomScrollbarProps = {

    trackVisibilityDecl:            PropTypes.oneOf(CustomScrollbarTrackVisibility.all),

    defaultTrackVisiblity:          CustomScrollbarTrackVisibility.default
};

CustomScrollbarProps.propTypes = {
    className:                      PropTypes.string,
    style:                          PropTypes.object,
    thumbSize:                      PropTypes.number,
    minThumbSize:                   PropTypes.number,
    autoUpdate:                     PropTypes.bool,
    horizontalTrackVisiblity:       CustomScrollbarProps.trackVisibilityDecl,
    verticalTrackVisiblity:         CustomScrollbarProps.trackVisibilityDecl,
    bare:                           PropTypes.bool,
    autoHide:                       PropTypes.bool,
    autoHideTimeout:                PropTypes.number,
    onScroll:                       PropTypes.func,
    onScrollStart:                  PropTypes.func,
    onScrollEnd:                    PropTypes.func,
    onResize:                       PropTypes.func,
    onContentResize:                PropTypes.func,
    elementRef:                     PropTypes.func,
    scrollElementRef:               PropTypes.func,
    onHorizontalParamsChanged:      PropTypes.func,
    onVerticalParamsChanged:        PropTypes.func
};

CustomScrollbarProps.propsDecl = PropTypes.shape(CustomScrollbarProps.propTypes);

CustomScrollbarProps.defaultProps = {
    className:                      '',
    minThumbSize:                   2,          // em
    autoUpdate:                     true,
    horizontalTrackVisiblity:       CustomScrollbarProps.defaultTrackVisiblity,
    verticalTrackVisiblity:         CustomScrollbarProps.defaultTrackVisiblity,
    bare:                           false,
    autoHide:                       false,
    autoHideTimeout:                3000
};

